import { render } from "./PiP.vue?vue&type=template&id=35b1ba3b&scoped=true"
import script from "./PiP.vue?vue&type=script&lang=js"
export * from "./PiP.vue?vue&type=script&lang=js"

import "./PiP.vue?vue&type=style&index=0&id=35b1ba3b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b1ba3b"]])

export default __exports__